var ScrollToTop = (function() {

  function bindClick() {
    millis = 700;

    $scrollLink.on("click", function(e) {
      e.preventDefault();
      $("html,body").animate({
        scrollTop: 0
      }, millis);
    });
  }

  function init() {
    if ($(".js-scrollTop").length) {
      $scrollLink = $(".js-scroll-top");
      bindClick();
    }
  }

  var $scrollLink, millis;

  return {
    init: init
  };

})();

export { ScrollToTop };